import type { User } from "@book-club/shared";
import { useQuery } from "@tanstack/react-query";
import membersService from "@/features/members/services/membersService";
import DURATIONS from "@/shared/constants/durations";
import { membersKeys } from "./membersQueryKeys";

/**
 * Fetches all members from Firestore
 * Uses 1 day staleTime for caching
 * @returns Query result with all members
 */
export function useMembers() {
    return useQuery<User[], Error>({
        gcTime: DURATIONS.ONE_DAY,
        queryFn: () => membersService.getAllMembers(),
        queryKey: membersKeys.list({}),
        staleTime: DURATIONS.ONE_DAY,
    });
}
